import React, { useEffect, useState } from 'react';
import { Stack } from 'office-ui-fabric-react';
import clsx from 'clsx';
import useWindowDimensions from './hooks/useWindowDimensions';
import NotAuthorizedUser from './pages/NotAuthorizedUser';
import { isMobileApp } from './utils';
import 'office-ui-fabric-core/dist/css/fabric.min.css';
import NavigationBar from './components/NavigationBar';
import { breakpoints } from './theme.style';
import styles from './App.style';
import './App.css';

const isMobile = isMobileApp();

const UnauthorizedApp = () => {
  const { width } = useWindowDimensions();
  const [isSmallScreen, setIsSmallScreen] = useState(width <= breakpoints.lg);

  useEffect(() => {
    setIsSmallScreen(width <= breakpoints.lg);
  }, [width]);

  return (
    <div className={styles.root}>
      {!isMobile && <NavigationBar />}
      <Stack horizontal>
        <Stack
          className={clsx(
            styles.mainContentContainer,
            isMobile && styles.mobileApp,
            isSmallScreen && styles.smallScreen,
          )}
        >
          <NotAuthorizedUser />
        </Stack>
      </Stack>
    </div>
  );
};

export default UnauthorizedApp;
